module.exports = __webpack_public_path__ + "static/img/4bg_1.30b8169.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/background/4bg_1.png
// module id = 694
// module chunks = 1